export const ASSETS = {
  logo: "/tsg-logo.png",
  oberliga: "/oberliga-westfalen.png",
  trainer:
    "https://static.prod-images.emergentagent.com/jobs/d70ed20d-58e1-47a3-923d-c3fa5fa44911/images/7d2a48359bba208708baf8706de4214069d4832e43c6a4966c9d2dc591135588.jpeg",
  heroBg:
    "https://images.unsplash.com/photo-1676746610993-fa0c050d1f6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};
